import { useGetStagesQuery } from "../../../../api/pipelineApi";
import { EmpresaCurrentDeal } from "../../../../types/empresa";

interface Props {
    currentDeal: EmpresaCurrentDeal;
}

export function StageProgressDealBar({ currentDeal }: Props) {

    const {
        data: stages,
        isSuccess,
    } = useGetStagesQuery(currentDeal.pipelineId);

    if(currentDeal.activeDeal === false)
        return(
        <div className="h-6 my-2 mx-4 rounded-md bg-gray-400 flex items-center justify-center">
            <p className="text-sm text-white text-center font-medium">No hay campaña activa</p>
        </div>
    );

    return (
        <div className="h-6 my-2 mx-4 rounded-md grid grid-cols-5 gap-x-[2px]">
            {isSuccess && stages.map((stage, index) => (
                <div 
                    key={index}
                    className={`
                        flex items-center justify-center
                        ${currentDeal.currentStageId >= stage.id ? "bg-green-700" : "bg-gray-400"}
                        ${index === 0 ? "rounded-l-md" : ""}
                        ${index === stages.length - 1 ? "rounded-r-md" : ""}
                    `}>
                    <p className="text-sm text-white text-center font-medium text-nowrap max-[1350px]:hidden">{stage.nombre}</p>
                </div>
            ))}
        </div>
    );
}